import { useEffect } from 'react';

/**
 * Custom hook to dynamically update document title and meta description.
 * This is crucial for SPA SEO and web crawlers that inspect page-specific metadata.
 */
export const useDocumentMetadata = (title: string, description?: string) => {
  useEffect(() => {
    // 1. Update Title
    const prevTitle = document.title;
    document.title = title;

    // Helper to find or create meta tag
    const updateMetaTag = (selector: string, attrName: string, attrValue: string, content: string) => {
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attrName, attrValue);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // 2. Update OG Title
    updateMetaTag('meta[property="og:title"]', 'property', 'og:title', title);

    // 3. Update Meta Description and OG Description
    if (description) {
      updateMetaTag('meta[name="description"]', 'name', 'description', description);
      updateMetaTag('meta[property="og:description"]', 'property', 'og:description', description);
    }

    // Optional Cleanup: reset to previous title (not strictly required for page routes, but clean)
    return () => {
      document.title = prevTitle;
    };
  }, [title, description]);
};
